export const Colors = {
  white: "#fff",
  black: "#000",
  // your colors
  fucci: "#e9726e",
  darkCyan: "#4fcda4",
  spaceGray: "#1c1c1e",
  darkGreen: "#163c3c",
  green: "#1e4620",
  brightGreen: "#39FF14",
  grey: "#1b1f23bf",
  charcolGrey: "#333A56",
  lightGray: "#E0E0E0",
  brightRed: "#EE4B2B",
  darkRed: "#4d0000",
  darkPurple: "#300a48",
  brightPurple: "#601390",
  lightBlue: "#a8dcf3",
  vividBlue: "#00A1E4",
  beige: "F8F0DF",
  candyAppleRed: "#FF0D0D",
  oriolesOrange: "#FF4E11",
  beer: "#FF8E15",
  saffron: "#FAB733",
  brass: "#ACB334",
  apple: "#69B34C",
  lightSpaceGray: "#484848",
  moneyGreen: "#007646",
  lightGray2: "#ececec",
  lightBlue2: "#c5f1ff",
  royalBlue: "#4169E1",
  deepSkyBlue: "#00BFFF",
  teal: "#008080",
  lavender: "#E6E6FA",
  paleGreen: "#98FB98",
  tomato: "#FF6347",
  slateGray: "#708090",
  midnightBlue: "#191970",
  plum: "#DDA0DD",
  gold: "#FFD700",
  sandyBrown: "#F4A460",
  skyBlue: "#87CEEB",
  steelBlue: "#4682B4",
  mediumSlateBlue: "#7B68EE",
  darkOliveGreen: "#556B2F",
  indianRed: "#CD5C5C",
  peru: "#CD853F",
  chocolate: "#D2691E",
  rosyBrown: "#BC8F8F",
  cadetBlue: "#5F9EA0",
  strangegreen: "#2c9567",
  darkstrangegreen: "#1f6c4b",
  brightstrangegreen: "#3ca97e",
  ratibBlue: "#a1c6ec",
  // Button colors
  buttonColor: "#4a90e2",
  buttonColor_hover: "#4285f4",
};
